var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSkipBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7.26522 6 7.51957 6.10536 7.70711 6.29289C7.89464 6.48043 8 6.73478 8 7V17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8946 7.26522 18 7 18C6.73478 18 6.48043 17.8946 6.29289 17.7071C6.10536 17.5196 6 17.2652 6 17V7C6 6.73478 6.10536 6.48043 6.29289 6.29289C6.48043 6.10536 6.73478 6 7 6ZM9.079 12.408C9.01379 12.3618 8.9606 12.3006 8.92389 12.2297C8.88718 12.1587 8.86803 12.0799 8.86803 12C8.86803 11.9201 8.88718 11.8413 8.92389 11.7703C8.9606 11.6994 9.01379 11.6382 9.079 11.592L16.212 6.556C16.2869 6.50323 16.3748 6.47205 16.4663 6.46586C16.5577 6.45968 16.649 6.47873 16.7303 6.52094C16.8117 6.56315 16.8798 6.62689 16.9274 6.7052C16.9749 6.78351 17.0001 6.87338 17 6.965V17.035C17.0001 17.1266 16.9749 17.2165 16.9274 17.2948C16.8798 17.3731 16.8117 17.4369 16.7303 17.4791C16.649 17.5213 16.5577 17.5403 16.4663 17.5341C16.3748 17.528 16.2869 17.4968 16.212 17.444L9.079 12.408Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skip-back.e8f26dc73512aa583f9e6abe1557702e.svg";